import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-registration.svg'
import _imports_1 from '@/assets/img/logo2.svg'
import _imports_2 from '@/assets/img/icons-img/unlock.svg'
import _imports_3 from '@/assets/img/graphic/register-banner.jpg'


const _withScopeId = n => (_pushScopeId("data-v-41bb6f00"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_2 = {
  key: 0,
  class: "reset-box"
}
const _hoisted_3 = { class: "reset" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header-logo",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_5 = { class: "reset__title" }
const _hoisted_6 = { class: "reset__text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "reset__text"
}
const _hoisted_9 = {
  key: 1,
  class: "reset-box"
}
const _hoisted_10 = { class: "reset" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header-logo",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_12 = { class: "reset__title" }
const _hoisted_13 = { class: "reset__text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "desktop--wrapper"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header--desktop" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desktop--container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "logo--desktop",
      src: _imports_1,
      alt: ""
    })
  ])
], -1))
const _hoisted_17 = { class: "desktop--container--sm" }
const _hoisted_18 = { class: "desktop--content" }
const _hoisted_19 = {
  key: 0,
  class: "desktop--content--body"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "unlock",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title--page" }, "Forgot your password?", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "No worries.", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "Enter your email address below and we will send you some reset instructions.", -1))
const _hoisted_24 = {
  key: 0,
  class: "reset__text"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Send Reset Instructions ")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-arrow-left" }, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Back to login ")
const _hoisted_28 = {
  key: 1,
  class: "reset-box"
}
const _hoisted_29 = { class: "reset" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header-logo",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "reset__title" }, "Forgot your Password?", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "reset__text" }, [
  /*#__PURE__*/_createTextVNode(" Thank you."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Please check your email for further instructions. ")
], -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Go to Login ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desktop--img--wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "banner"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createBlock(_component_el_container, {
        key: 0,
        direction: "vertical"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_header, null, {
            "top-left": _withCtx(() => [
              (_ctx.resetForm)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/login",
                    class: "back-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.resetForm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$localize('reset.password.title')), 1),
                  _createElementVNode("p", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.$localize('reset.password.tip1')), 1),
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.$localize('reset.password.tip2')), 1)
                  ])
                ]),
                _createVNode(_component_Form, {
                  as: "el-form",
                  class: "form-box",
                  "validation-schema": _ctx.schema,
                  onSubmit: _ctx.onSubmit
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_app_input, {
                      ref: "inputEmail",
                      name: "email",
                      "prop-error": _ctx.emailError,
                      label: _ctx.$localize('reset.password.email'),
                      placeholder: _ctx.$localize('reset.password.email.placeholder')
                    }, null, 8, ["prop-error", "label", "placeholder"]),
                    (_ctx.errors.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.errors), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_app_button, {
                      type: "primary",
                      "native-type": "submit",
                      class: "w-100 el-button-lg",
                      disabled: _ctx.dataLoading,
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$localize('reset.password.reset.instructions')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["validation-schema", "onSubmit"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.resetForm)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.$localize('reset.password.title2')), 1),
                  _createElementVNode("p", _hoisted_13, [
                    _createTextVNode(_toDisplayString(_ctx.$localize('reset.password.success1')), 1),
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.$localize('reset.password.success2')), 1)
                  ]),
                  _createVNode(_component_app_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login'))),
                    type: "primary",
                    class: "w-100 el-button-lg",
                    disabled: _ctx.dataLoading,
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('reset.password.go.to.login.button')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_ctx.resetForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23,
                  _createVNode(_component_Form, {
                    onSubmit: _ctx.onSubmit,
                    "validation-schema": _ctx.schema,
                    as: "el-form"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_app_input, {
                        name: "email",
                        label: "Email Address",
                        placeholder: "jake.nelson@emailaddress.com"
                      }),
                      (_ctx.errors.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.errors), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "large",
                        class: "w-100 btn-reset",
                        "native-type": "submit",
                        round: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSubmit", "validation-schema"]),
                  _createVNode(_component_el_button, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/login'))),
                    type: "default",
                    size: "large",
                    class: "w-100 btn-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26,
                      _hoisted_27
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!_ctx.resetForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _hoisted_31,
                    _hoisted_32,
                    _createVNode(_component_app_button, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/login'))),
                      type: "primary",
                      class: "w-100 el-button-lg",
                      disabled: _ctx.dataLoading,
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_34
      ]))
}